var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mark_email_read_black_24dp 1",
    clipPath: "url(#clip0_129_1256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M89.1666 17.8334H17.8333C12.9291 17.8334 8.96121 21.8459 8.96121 26.75L8.91663 80.25C8.91663 85.1542 12.9291 89.1667 17.8333 89.1667H53.5V80.25H17.8333V35.6667L53.5 57.9584L89.1666 35.6667V57.9584H98.0833V26.75C98.0833 21.8459 94.0708 17.8334 89.1666 17.8334ZM53.5 49.0417L17.8333 26.75H89.1666L53.5 49.0417ZM77.3075 98.0834L61.525 82.3009L67.8112 76.0146L77.2629 85.4663L96.1662 66.563L102.542 72.8492L77.3075 98.0834Z",
    fill: "url(#paint0_linear_129_1256)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_129_1256",
    x1: 16.3306,
    y1: 57.8466,
    x2: 92.9415,
    y2: 57.8466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ADF23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_1256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 107,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkEmail);
export default __webpack_public_path__ + "static/media/mark-email.9c2a802339fb6653492d804ca330ca7a.svg";
export { ForwardRef as ReactComponent };